export const WORK_SHEET_DATA_NAME = "Dữ liệu"
export const WORK_SHEET_CHART_NAME = "Biểu đồ"
export const WORK_BOOK_NAME = "Thống kê-"
export const CHART_SCALE = 0.7
